import { render } from "./loginSubsciber.vue?vue&type=template&id=0afb5983&ts=true"
import script from "./loginSubsciber.vue?vue&type=script&lang=ts"
export * from "./loginSubsciber.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/www-root/data/www/brazilist-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__